export const PROTOCOL_TYPES_IMG_NAME: Record<string, string> = {
  Cardiac: "cardiac",
  Abdominal: "abdominal",
  "Head and Neck": "ent",
  Orthopedic: "orthopedic",
  Other: "other",
};
